/**
 * Converts a string to a URL-friendly slug
 * - Converts to lowercase
 * - Replaces sequences of non-alphanumeric characters with a single dash
 * - Removes leading and trailing dashes
 *
 * @example
 * // returns "gas-lng-carbon"
 * slugify("Gas, LNG & Carbon");
 */
export function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
}
